<template>
	<div>
		<el-form label-width="560px">
			<el-form-item label="是否开启支付活动">
				<el-radio-group v-model="is_pay">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="0">否</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="单独设置优惠" v-if="is_pay == 1">
				<el-radio-group v-model="single_discount">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="0">否</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="互斥规则" v-if="is_pay == 1&&single_discount == 1">
				<el-checkbox-group v-model="mutex">
					<el-checkbox label="1">积分</el-checkbox>
					<el-checkbox label="2">优惠券</el-checkbox>
					<el-checkbox label="3">活动优惠</el-checkbox>
				</el-checkbox-group>
				<div v-if="mutex.length > 0">
					<div>
						优先适用顺序
					</div>
					<el-tag
						v-for="(item, index) in mutex"
						:key="index"
						style="margin-left: 5px;"
					>
						{{
							index +
								1 +
								" " +
								(item == 1 ? "积分" : item == 2 ? "优惠券" : "活动优惠")
						}}
					</el-tag>
				</div>
				<div>
					<div>
						提示: 1.勾选一个互斥不生效;
					</div>
					<div style="text-indent: 30px">
						2.勾选两个以上互斥生效,都不选则没有互斥。
					</div>
				</div>
			</el-form-item>
			<el-form-item label="优惠内容" v-if="is_pay == 1&&single_discount == 1">
				<el-radio-group v-model="type" @change="selcte">
					<el-radio label="无限制">无限制</el-radio>
					<el-radio label="区间满减">区间满减</el-radio>
					<el-radio label="每升满减">每满减</el-radio>
				</el-radio-group>
				<div v-if="type == '无限制'">
					<div>
						<el-radio-group v-model="type2">
							<el-radio label="统一优惠">统一优惠</el-radio>
							<el-radio label="类别优惠">类别优惠</el-radio>
							<el-radio label="油品优惠">油品优惠</el-radio>
						</el-radio-group>
					</div>
					<div v-if="type2 == '统一优惠'">
						<el-form label-width="100px">
							<div>
								<el-radio-group v-model="discount.unified_offer_value.type">
									<el-radio :label="0">
										折扣
										<el-input
											placeholder="请输入(数字)"
											v-model="discount.unified_offer_value.discount"
											size="small"
										>
										</el-input>
										折
									</el-radio>
									<br />
									<el-radio :label="1" style="margin-top: 10px;">
										每升减
										<el-input
											v-model="discount.unified_offer_value.money"
											size="small"
											placeholder="请输入(数字)"
										></el-input>
										元
									</el-radio>
								</el-radio-group>
							</div>
						</el-form>
					</div>
					<div v-if="type2 == '类别优惠'">
						<div
							v-for="(item, i) in discount.cate_offer_value"
							:key="i"
							style="display: flex;background-color: #f8f8ff;width: 580px;margin-top: 10px;"
						>
							<div
								style="border-right: 1px solid #cccccc;padding: 5px;margin-right: 5px;"
							>
								<span>油品类型 </span>
								<el-select
									size="small"
									v-model="item.cate"
									placeholder="请选择"
								>
									<el-option
										v-for="ite in you_type"
										:key="ite.id"
										:label="ite.name"
										:value="ite.id"
									>
									</el-option>
								</el-select>
								<br />
								<el-button
									type="text"
									style="margin-top: 10px;margin-left: 180px;"
									@click="roule_del(i)"
									>删除</el-button
								>
							</div>
							<div>
								<div>
									<el-radio-group v-model="item.type">
										<el-radio :label="0" style="margin-top: 10px;">
											折扣
											<el-input
												placeholder="请输入(数字)"
												v-model="item.discount"
												size="small"
											>
											</el-input>
											折
										</el-radio>
										<br />
										<el-radio :label="1" style="margin-top: 10px;">
											每升减
											<el-input
												v-model="item.money"
												size="small"
												placeholder="请输入(数字)"
											></el-input>
											元
										</el-radio>
									</el-radio-group>
								</div>
							</div>
						</div>
						<el-button type="primary" size="small" @click="add_rule"
							>增加规则</el-button
						>
					</div>
					<div v-if="type2 == '油品优惠'">
						<div
							v-for="(item, i) in discount.goods_offer_value"
							:key="i"
							style="display: flex;background-color: #f8f8ff;width: 580px;margin-top: 10px;"
						>
							<div
								style="border-right: 1px solid #cccccc;padding: 5px;margin-right: 5px;"
							>
								<span>油品 </span>
								<el-select
									size="small"
									v-model="item.goods"
									placeholder="请选择"
								>
									<el-option
										v-for="(ites, i) in youpinList"
										:key="i"
										:label="ites.name"
										:value="ites.id"
									>
									</el-option>
								</el-select>
								<br />
								<el-button
									type="text"
									style="margin-top: 10px;margin-left: 180px;"
									@click="roule_del(i)"
									>删除</el-button
								>
							</div>
							<div>
								<div>
									<el-radio-group v-model="item.type">
										<el-radio :label="0" style="margin-top: 10px;">
											折扣
											<el-input
												placeholder="请输入(数字)"
												v-model="item.discount"
												size="small"
											>
											</el-input>
											折
										</el-radio>
										<br />
										<el-radio :label="1" style="margin-top: 10px;">
											每升减
											<el-input
												v-model="item.money"
												size="small"
												placeholder="请输入(数字)"
											></el-input>
											元
										</el-radio>
									</el-radio-group>
								</div>
							</div>
						</div>
						<el-button type="primary" size="small" @click="add_rule"
							>增加规则</el-button
						>
					</div>
				</div>
				<div v-else>
					<div
						v-for="(item, i) in type == '区间满减'
							? discount.full_discount
							: discount.every_discount"
						:key="i"
					>
						<div>
							<div style="display: inline-block;margin-right: 20px;">
								满
								<el-input
									v-model="item.num"
									size="small"
									placeholder="请输入(数字)"
								></el-input>
								元
							</div>
							<el-radio-group v-model="item.type">
								<el-radio label="统一优惠">统一优惠</el-radio>
								<el-radio label="类别优惠">类别优惠</el-radio>
								<el-radio label="油品优惠">油品优惠</el-radio>
							</el-radio-group>
							<el-button
								v-if="type == '区间满减'"
								type="danger"
								size="small"
								@click="del(i, type)"
								style="margin-left: 10px;color: #fff;"
								>删除区间</el-button
							>
						</div>
						<div v-if="item.type == '统一优惠'">
							<el-form label-width="100px">
								<div>
									<el-radio-group v-model="item.unified_offer_value.type">
										<el-radio :label="0">
											折扣
											<el-input
												placeholder="请输入(数字)"
												v-model="item.unified_offer_value.discount"
												size="small"
											>
											</el-input
											>折</el-radio
										>
										<br />
										<el-radio :label="1" style="margin-top: 10px;">
											每升减
											<el-input
												v-model="item.unified_offer_value.money"
												size="small"
												placeholder="请输入(数字)"
											></el-input>
											元</el-radio
										>
										<br />
										<el-radio :label="2" style="margin-top: 10px;">
											优惠
											<el-input
												v-model="item.unified_offer_value.dec_money"
												size="small"
												placeholder="请输入(数字)"
											></el-input>
											元</el-radio
										>
									</el-radio-group>
								</div>
							</el-form>
						</div>
						<div v-if="item.type == '类别优惠'">
							<div
								v-for="(items, i) in item.cate_offer_value"
								:key="i"
								style="display: flex;background-color: #f8f8ff;width: 580px;margin-top: 10px;"
							>
								<div
									style="border-right: 1px solid #cccccc;padding: 5px;margin-right: 5px;"
								>
									<div>
										<span>油品类型 </span>
										<el-select
											size="small"
											v-model="items.cate"
											placeholder="请选择"
										>
											<el-option
												v-for="ite in you_type"
												:key="ite.id"
												:label="ite.name"
												:value="ite.id"
											>
											</el-option>
										</el-select>
									</div>
								</div>
								<div>
									<div>
										<el-radio-group v-model="items.type">
											<el-radio :label="0">
												折扣
												<el-input
													placeholder="请输入(数字)"
													v-model="items.discount"
													size="small"
												>
												</el-input
												>折</el-radio
											>
											<br />
											<el-radio :label="1" style="margin-top: 10px;">
												每升减
												<el-input
													v-model="items.money"
													size="small"
													placeholder="请输入(数字)"
												></el-input>
												元</el-radio
											>
											<br />
											<el-radio :label="2" style="margin-top: 10px;">
												优惠
												<el-input
													v-model="items.dec_money"
													size="small"
													placeholder="请输入(数字)"
												></el-input>
												元</el-radio
											>
										</el-radio-group>
									</div>
								</div>
								<el-button
									size="small"
									style="height: 30px;"
									type="danger"
									icon="el-icon-close"
									@click="roule_del(i, item)"
								></el-button>
							</div>

							<el-button size="small" type="primary" @click="add_rule(item)"
								>增加规则</el-button
							>
						</div>
						<div v-if="item.type == '油品优惠'">
							<div
								v-for="(items, i) in item.goods_offer_value"
								:key="i"
								style="display: flex;background-color: #f8f8ff;width: 580px;margin-top: 10px;"
							>
								<div
									style="border-right: 1px solid #cccccc;padding: 5px;margin-right: 5px;"
								>
									<span>油品 </span>
									<el-select
										size="small"
										v-model="items.goods"
										placeholder="请选择"
									>
										<el-option
											v-for="(ites, i) in youpinList"
											:key="i"
											:label="ites.name"
											:value="ites.id"
										>
										</el-option>
									</el-select>
								</div>
								<div>
									<div>
										<el-radio-group v-model="items.type">
											<el-radio :label="0">
												折扣
												<el-input
													placeholder="请输入(数字)"
													v-model="items.discount"
													size="small"
												>
												</el-input
												>折</el-radio
											>
											<br />
											<el-radio :label="1" style="margin-top: 10px;">
												每升减
												<el-input
													v-model="items.money"
													size="small"
													placeholder="请输入(数字)"
												></el-input>
												元</el-radio
											>
											<br />
											<el-radio :label="2" style="margin-top: 10px;">
												优惠
												<el-input
													v-model="items.dec_money"
													size="small"
													placeholder="请输入(数字)"
												></el-input>
												元</el-radio
											>
										</el-radio-group>
									</div>
								</div>
								<el-button
									size="small"
									style="height: 30px;"
									type="danger"
									icon="el-icon-close"
									@click="roule_del(i, item)"
								></el-button>
							</div>
							<el-button size="small" type="primary" @click="add_rule(item)"
								>增加规则</el-button
							>
						</div>
					</div>
				</div>
				<el-button v-if="type == '区间满减'" size="small" @click="add(type)"
					>增加区间</el-button
				>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
import { oilsTypeOptions, goodsList, goodsOptions } from "@/api/vip";
import { mapGetters } from "vuex";
export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	data() {
		return {
			you_type: [],
			mutex: [],
			youpinList: [],
			is_pay: 0,
			single_discount: 0,
			discount: {
        unified_offer: 0,
				unified_offer_value: {
					type: null,
					discount_status: 0,
					discount: "",
					money_status: 0,
					money: "",
        },
        cate_offer: 0,
				cate_offer_value: [
					{
						type: null,
						cate: "",
						discount_status: 0,
						discount: "",
						money_status: 0,
						money: "",
					},
        ],
        goods_offer: 0,
				goods_offer_value: [
					{
						type: null,
						goods: "",
						discount_status: 0,
						discount: "",
						money_status: 0,
						money: "",
					},
        ],
        
        full_reduction: 0, 
        full_discount: [],
        every_reduction: 0,   
        every_discount: [],    
			},
			type: "无限制",
			type2: "统一优惠",
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.get_oilList();
			this.get_goodsList();
		},
		add_rule(item) {
			if (this.type == "无限制" && this.type2 == "类别优惠") {
				this.discount.cate_offer_value.push({
					cate: "",
					discount_status: 0,
					discount: "",
					money_status: 0,
					money: "",
				});
      }
			if (this.type == "无限制" && this.type2 == "油品优惠") {
				this.discount.goods_offer_value.push({
					goods: "",
					discount_status: 0,
					discount: "",
					money_status: 0,
					money: "",
				});
      }
			if (this.type == "区间满减" && item.type == "类别优惠") {
				item.cate_offer_value.push({
					type: null,
					cate: "",
					discount_status: 0,
					discount: "",
					money_status: 0,
					money: "",
					dec_status: 0,
					dec_money: "",
				});
      }
			if (this.type == "区间满减" && item.type == "油品优惠") {
				item.goods_offer_value.push({
					type: null,
					goods: "",
					discount_status: 0,
					discount: "",
					money_status: 0,
					money: "",
					dec_status: 0,
					dec_money: "",
				});
      }
			if (this.type == "每升满减" && item.type == "类别优惠") {
				item.cate_offer_value.push({
					type: null,
					cate: "",
					discount_status: 0,
					discount: "",
					money_status: 0,
					money: "",
					dec_status: 0,
					dec_money: "",
				});
      }
			if (this.type == "每升满减" && item.type == "油品优惠") {
				item.goods_offer_value.push({
					goods: "",
					type: null,
					discount_status: 0,
					discount: "",
					money_status: 0,
					money: "",
					dec_status: 0,
					dec_money: "",
				});
			}
		},
		roule_del(i, item) {
			if (this.type == "无限制" && this.type2 == "类别优惠") {
				if (this.discount.cate_offer_value.length == 1) {
					this.$message("至少留一个");
				} else {
					this.discount.cate_offer_value.splice(i, 1);
				}
      }
			if (this.type == "无限制" && this.type2 == "油品优惠") {
				if (this.discount.goods_offer_value.length == 1) {
					this.$message("至少留一个");
				} else {
					this.discount.goods_offer_value.splice(i, 1);
				}
      }
			if (this.type == "区间满减" && item.type == "类别优惠") {
				if (item.cate_offer_value.length == 1) {
					this.$message("至少留一个");
				} else {
					item.cate_offer_value.splice(i, 1);
				}
      }
			if (this.type == "区间满减" && item.type == "油品优惠") {
				if (item.goods_offer_value.length == 1) {
					this.$message("至少留一个");
				} else {
					item.goods_offer_value.splice(i, 1);
				}
      }
			if (this.type == "每升满减" && item.type == "类别优惠") {
				if (item.cate_offer_value.length == 1) {
					this.$message("至少留一个");
				} else {
					item.cate_offer_value.splice(i, 1);
				}
      }
			if (this.type == "每升满减" && item.type == "油品优惠") {
				if (item.goods_offer_value.length == 1) {
					this.$message("至少留一个");
				} else {
					item.goods_offer_value.splice(i, 1);
				}
			}
		},
		//获取油品类别
		async get_oilList() {
			try {
				var data = {
					app_id: this.app_id,
				};
				const res = await oilsTypeOptions(data);
				if (res.code == 200) {
					this.you_type = res.data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		//获取油品
		async get_goodsList() {
			try {
				const res = await goodsOptions({
					app_id: this.app_id,
				});
				if (res.code == 200) {
					this.youpinList = res.data;
					console.log(this.youpinList);
				}
			} catch (e) {
				console.log(e);
			}
		},
		//选择
		selcte(val) {
			console.log(val);
			if (val == "区间满减") {
				this.discount.full_discount = [
					{
						num: "",
						type: "类别优惠",
						unified_offer: 0,
						unified_offer_value: {
							type: null,
							discount_status: 0,
							discount: "",
							money_status: 0,
							money: "",
							dec_status: 0,
							dec_money: "",
						},
						cate_offer: 0,
						cate_offer_value: [
							{
								type: null,
								cate: "",
								discount_status: 0,
								discount: "",
								money_status: 0,
								money: "",
								dec_status: 0,
								dec_money: "",
							},
						],
						goods_offer: 0,
						goods_offer_value: [
							{
								type: null,
								goods: "",
								discount_status: 0,
								discount: "",
								money_status: 0,
								money: "",
								dec_status: 0,
								dec_money: "",
							},
						],
					},
				];
			}
			if (val == "每升满减") {
				this.discount.every_discount = [
					{
						num: "",
						type: "类别优惠",
						unified_offer: 0,
						unified_offer_value: {
							type: null,
							discount_status: 0,
							discount: "",
							money_status: 0,
							money: "",
							dec_status: 0,
							dec_money: "",
						},
						cate_offer: 0,
						cate_offer_value: [
							{
								type: null,
								cate: "",
								discount_status: 0,
								discount: "",
								money_status: 0,
								money: "",
								dec_status: 0,
								dec_money: "",
							},
						],
						goods_offer: 0,
						goods_offer_value: [
							{
								type: null,
								goods: "",
								discount_status: 0,
								discount: "",
								money_status: 0,
								money: "",
								dec_status: 0,
								dec_money: "",
							},
						],
					},
				];
			}
		},
		//增加
		add(type) {
			if (type == "区间满减") {
				this.discount.full_discount.push({
					type: "类别优惠",
					unified_offer: 0,
					unified_offer_value: {
						type: null,
						discount_status: 0,
						discount: "",
						money_status: 0,
						money: "",
						dec_status: 0,
						dec_money: "",
					},
					cate_offer: 0,
					cate_offer_value: [
						{
							type: null,
							cate: "",
							discount_status: 0,
							discount: "",
							money_status: 0,
							money: "",
							dec_status: 0,
							dec_money: "",
						},
					],
					goods_offer: 0,
					goods_offer_value: [
						{
							type: null,
							goods: "",
							discount_status: 0,
							discount: "",
							money_status: 0,
							money: "",
							dec_status: 0,
							dec_money: "",
						},
					],
				});
			}
			if (type == "每升满减") {
				this.discount.every_discount.push({
					type: "类别优惠",
					unified_offer: 0,
					unified_offer_value: {
						type: null,
						discount_status: 0,
						discount: "",
						money_status: 0,
						money: "",
						dec_status: 0,
						dec_money: "",
					},
					cate_offer: 0,
					cate_offer_value: [
						{
							type: null,
							cate: "",
							discount_status: 0,
							discount: "",
							money_status: 0,
							money: "",
							dec_status: 0,
							dec_money: "",
						},
					],
					goods_offer: 0,
					goods_offer_value: [
						{
							type: null,
							goods: "",
							discount_status: 0,
							discount: "",
							money_status: 0,
							money: "",
							dec_status: 0,
							dec_money: "",
						},
					],
				});
			}
		},
		//删除
		del(i, type) {
			if (type == "区间满减") {
				if (this.discount.full_discount.length == 1) {
					this.$message("至少留一个");
				} else {
					this.discount.full_discount.splice(i, 1);
				}
			}
			if (type == "每升满减") {
				if (this.discount.every_discount.length == 1) {
					this.$message("至少留一个");
				} else {
					this.discount.every_discount.splice(i, 1);
				}
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.el-input {
	width: 120px !important;
}
</style>
